import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MainRoute } from 'src/navigations/Routes/MainRoute';
import { EventIdQueryParam } from 'src/utils/constants/constants';
import { ListingQuery } from 'src/WebApiController';

import { useAppContext } from '../AppContext';
import { useFilterQueryContextFilterQuerySelector } from '../FilterQueryContext/FilterQueryContext.selectors';

export const useSyncEventWithFilters = (
  selectedEventVirtualId: string | undefined,
  enabled: boolean
) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { mainRoute } = useAppContext();

  const [filterQuery, setFilterQuery] =
    useFilterQueryContextFilterQuerySelector<ListingQuery>();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    // Only sync the URL with the selected event when we're on the InventoryEvent page,
    if (mainRoute !== MainRoute.InventoryEvent) {
      return;
    }
    const currentEventId = searchParams.get(EventIdQueryParam);
    if (selectedEventVirtualId && currentEventId !== selectedEventVirtualId) {
      setFilterQuery({
        ...filterQuery,
        eventOrMappingIds: [selectedEventVirtualId!],
      });
      searchParams.set(EventIdQueryParam, selectedEventVirtualId);
      navigate(`/inventory/event?${searchParams.toString()}`, {
        replace: true,
      });
    }
    // Don't want to include filterQuery to avoid re-render of the hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, searchParams, selectedEventVirtualId, setFilterQuery]);
};
